module.exports = __webpack_public_path__ + "img/Gallery_1_08.f2e156ab.jpeg";